import Asset from "../components/asset/assetList/AssetList";
import DeviceManagement from "../components/device-management/DeviceManagement";
import DeviceOnboarding from "../components/device-onboarding/DeviceOnboarding";
import ReseFileupload from "../components/rese/rese-file-upload/ReseFileupload";
import CommandAndControl from "../components/command-and-control/CommandAndControl";
import ShellyReplacement from "../components/shelly-replacement/ShellyReplacement";
import AcuviewMonitoring from "../components/acuview-ipad-monitoring/AcuviewMonitoring";

import PingProbeInventory from "../components/pingprobe/inventory/PingProbeInventory";
import PingProbeIncidentSuppression from "../components/pingprobe/incident-suppression/PingProbeIncidentSuppression";
import PingProbeSuppressionLogs from "../components/pingprobe/suppression-logs/PingProbeSuppressionLogs";
import LivePing from "../components/pingprobe/LivePing"

import IncidentConfig from "../components/incident-config/IncidentConfig";

import SnowWrapper from "../components/snow-wrapper/SnowWrapper";

import AutomationLogs from "../components/rpa/AutomationLogs";
import IncidentSummary from "../components/command-center-automation/remaining-cc-usecases/incident-summary/IncidentSummary";
import RitSummary from "../components/command-center-automation/remaining-cc-usecases/rit-summary/RitSummary";
import ServiceRestartLogs from "../components/epe/ServiceRestartLogs";

import NetworkAutomation from "../components/network-automation/NetworkAutomation";
import NacAutomation from "../components/network-automation/nac-automation/NacAutomation";
import CircuitVpn from "../components/network-automation/circuit-vpn/CircuitVpn";
import ServiceMainLogs from "../components/service-main/ServiceMainLogs"

import CPUsageTracker from "../components/cp-usage-tracker/billing-automation/CPUsageTracker";
import CPDeployment from "../components/cp-usage-tracker/CPDeployment";

import ShellyFirmware from "../components/shelly-firmware/ShellyFirmware"

import GARemoteCommand from "../components/ares/GARemoteCommand";

import GAAzureVmAlloy from "../components/ares/GAAzureVmAlloy";

import IncidentSuppressionRequest from "../components/incident-suppression/incident-suppression-request/IncidentSuppressionRequest";
import IncidentSuppressionLogs from "../components/incident-suppression/incident-suppression-logs/IncidentSuppressionLogs";

import ReseAlertSuppressionRequest from "../components/rese/alert-suppression/alert-suppression-request/ReseAlertSuppressionRequest";
import ReseLeakAlertSuppressionRequest from "../components/rese/alert-suppression/leak-detection-alert-suppression-request/ReseLeakAlertSuppressionRequest";
import ReseAlertSuppressionLogs from "../components/rese/alert-suppression/alert-suppression-logs/ReseAlertSuppressionLogs";
import ReseStore from "../components/rese/store/ReseStore";
import ReseUser from "../components/rese/rese-users/ReseUser";
import RESECommand from "../components/rese/command-and-control/RESECommand";
import ReseBms from "../components/rese/bms/ReseBms";
import ReseLeakDetectionMonitoring from "../components/rese/leak-detection-monitoring/ReseLeakDetectionMonitoring";

import DataCategorization from "../components/data-categorization/DataCategorization";

import DeviceDetailsTable from "../components/supply-chain/device-table/DeviceDetailsTable";
import DCOnboarding from "../components/supply-chain/dc-onboarding/Onboarding";
import Dashboard from "../components/supply-chain/dashboard/Dashboard";

import { ReactComponent as DeviceManagementIcon } from "../images/device-management-logo-blue.svg";
import { ReactComponent as PingProbeIcon } from "../images/pingprobe-logo-blue.svg";
import { ReactComponent as IncidentConfigIcon } from "../images/inc-config-logo-blue.svg";
import { ReactComponent as SnowWrapperIcon } from "../images/snow-wrapper-logo-blue.svg";
import { ReactComponent as AutomationLogsIcon } from "../images/automation-logo-blue.svg";
import { ReactComponent as CradlePointIcon } from "../images/cp-logo-blue.svg";
import { ReactComponent as ShellyFirmwareIcon } from "../images/shelly-firmware-logo-blue.svg"
import { ReactComponent as GrafanaAgentRemoteCommandIcon } from "../images/remote-command-blue.svg"
import { ReactComponent as IncidentSuppressionIcon } from "../images/incident-suppression-blue.svg"
import { ReactComponent as ReseIcon } from "../images/rese-icon-blue.svg";
import { ReactComponent as DataCategorizationIcon } from "../images/inc-config-logo-blue.svg";
import { ReactComponent as DataCategorizationActiveIcon } from "../images/inc-config-logo-white.svg";


import { ReactComponent as DeviceManagementActiveIcon } from "../images/device-management-logo-white.svg";
import { ReactComponent as PingProbeActiveIcon } from "../images/pingprobe-logo-white.svg";
import { ReactComponent as IncidentConfigActiveIcon } from "../images/inc-config-logo-white.svg";
import { ReactComponent as SnowWrapperActiveIcon } from "../images/snow-wrapper-logo-white.svg";
import { ReactComponent as AutomationLogsActiveIcon } from "../images/automation-logo-white.svg";
import { ReactComponent as CradlePointActiveIcon } from "../images/cp-logo-white.svg";
import { ReactComponent as ShellyFirmwareActiveIcon } from "../images/shelly-firmware-logo-white.svg"
import { ReactComponent as GrafanaAgentRemoteCommandActiveIcon } from "../images/remote-command-white.svg"
import { ReactComponent as IncidentSuppressionActiveIcon } from "../images/incident-suppression-white.svg"
import { ReactComponent as ReseActiveIcon } from "../images/rese-icon-white.svg";


export const tabList = [
    {
        key: "1",
        header: "Device Management",
        path: "/admin/device-management",
        component: <></>,
        icon: <DeviceManagementIcon />,
        activeIcon: <DeviceManagementActiveIcon />,
        roles: [
            "AssetManagement.Read",
            "DeviceManagement.Read",
            "DeviceManagement.Write",
            "CommandControl.Read",
            "CommandControl.Write",
            "ShellyReplacement.Read",
            "ShellyReplacement.Write",
        ],
        child: [
            {
                key: "1.1",
                header: "Assets",
                path: "/admin/device-management/assets",
                component: Asset,
                icon: "",
                roles: ["AssetManagement.Read"],
                child: [],
            },
            {
                key: "1.2",
                header: "Devices",
                path: "/admin/device-management/devices",
                component: DeviceManagement,
                icon: "",
                roles: ["DeviceManagement.Read"],
                child: [],
            },
            {
                key: "1.3",
                header: "Onboarding",
                path: "/admin/device-management/onboarding",
                component: DeviceOnboarding,
                icon: "",
                roles: ["DeviceManagement.Write"],
                child: [],
            },
            {
                key: "1.4",
                header: "Command and Control",
                path: "/admin/device-management/command-and-control",
                component: CommandAndControl,
                icon: "",
                roles: ["CommandControl.Read", "CommandControl.Write"],
                child: [],
            },
            {
                key: "1.5",
                header: "Shelly Replacement",
                path: "/admin/device-management/shelly-replacement",
                component: ShellyReplacement,
                icon: "",
                roles: ["ShellyReplacement.Read", "ShellyReplacement.Write"],
                child: [],
            },
            {
                key: "1.6",
                header: "iPad Monitoring",
                path: "/admin/device-management/acuview-ipad-monitoring",
                component: AcuviewMonitoring,
                icon: "",
                roles: ["AssetManagement.Read"],
                child: [],
            },
        ],
    },
    {
        key: "2",
        header: "Ping Probe",
        path: "/admin/ping-probe",
        component: <></>,
        icon: <PingProbeIcon />,
        activeIcon: <PingProbeActiveIcon />,
        roles: ["PingProbe.Read", "PingProbe.Write"],
        child: [
            {
                key: "2.1",
                header: "Inventory",
                path: "/admin/ping-probe/inventory",
                component: PingProbeInventory,
                icon: "",
                roles: ["PingProbe.Read", "PingProbe.Write"],
                child: [],
            },
            {
                key: "2.2",
                header: "Suppression Rule",
                path: "/admin/ping-probe/suppression-rule",
                component: PingProbeIncidentSuppression,
                icon: "",
                roles: ["PingProbe.Write"],
                child: [],
            },
            {
                key: "2.3",
                header: "Suppression Logs",
                path: "/admin/ping-probe/suppression-logs",
                component: PingProbeSuppressionLogs,
                icon: "",
                roles: ["PingProbe.Write"],
                child: [],
            },          
            {
                key: "2.4",
                header: "Live Ping",
                path: "/admin/ping-probe/live-ping",
                component: LivePing,
                icon: "",
                roles: ["PingProbe.Read", "PingProbe.Write"],
                child: [],
            },
        ],
    },
    {
        key: "3",
        header: "Incident Configuration",
        path: "/admin/incident-configuration",
        component: IncidentConfig,
        icon: <IncidentConfigIcon />,
        activeIcon: <IncidentConfigActiveIcon />,
        roles: ["IncidentExclusion.Read", "IncidentExclusion.Write"],
        child: [],
    },
    {
        key: "4",
        header: "SNOW Wrapper",
        path: "/admin/snow-wrapper",
        component: SnowWrapper,
        icon: <SnowWrapperIcon />,
        activeIcon: <SnowWrapperActiveIcon />,
        roles: ["SnowWrapper.Read", "SnowWrapper.Write"],
        child: [],
    },
    {
        key: "5",
        header: "Automation Logs",
        path: "/admin/automation-logs",
        component: <></>,
        icon: <AutomationLogsIcon />,
        activeIcon: <AutomationLogsActiveIcon />,
        roles: ["RPA.Read", "RPA.Write", "CCLogs.Read", "CCLogs.Write", "EPE.Read","NetworkAutomation.Read", "NetworkAutomation.Write","ServiceMain.Read"],
        child: [
            {
                key: "5.1",
                header: "Command Center Automation",
                path: "/admin/automation-logs/command-center-automation",
                component: <></>,
                icon: "",
                roles: ["CCLogs.Read", "CCLogs.Write"],
                child: [
                    {
                        key: "5.1.1",
                        header: "Grafana Based Alerts",
                        path: "/admin/automation-logs/command-center-automation/incident-based-automation",
                        component: IncidentSummary,
                        icon: "",
                        roles: ["CCLogs.Read", "CCLogs.Write"],
                        child:[],
                    },
                    {
                        key: "5.1.2",
                        header: "DNS Update",
                        path: "/admin/automation-logs/command-center-automation/rit-based-automation",
                        component: RitSummary,
                        icon: "",
                        roles: ["CCLogs.Read", "CCLogs.Write"],
                        child:[],
                    }
                ],
            },
            {
                key: "5.2",
                header: "Network Automation",
                path: "/admin/automation-logs/network-automation",
                component: <></>,
                icon: "",
                roles: ["NetworkAutomation.Read", "NetworkAutomation.Write"],
                child:[
                    {
                        key: "5.2.1",
                        header: "Meraki Firewall",
                        path: "/admin/automation-logs/network-automation/meraki-firewall-automation",
                        component: NetworkAutomation,
                        icon: "",
                        roles: ["NetworkAutomation.Read", "NetworkAutomation.Write"],
                        child:[],
                    },
                    {
                        key: "5.2.2",
                        header: "NAC",
                        path: "/admin/automation-logs/network-automation/nac-automation",
                        component: NacAutomation,
                        icon: "",
                        roles: ["NetworkAutomation.Read"],
                        child:[],
                    },
                    {
                        key: "5.2.3",
                        header: "Circuit VPN",
                        path: "/admin/automation-logs/network-automation/circuit-vpn",
                        component: CircuitVpn,
                        icon: "",
                        roles: ["NetworkAutomation.Read"],
                        child:[],
                    },
                ],
            },
            {
                key: "5.3",
                header: "Voice Automation",
                path: "/admin/automation-logs/voice-automation",
                component: AutomationLogs,
                icon: "",
                roles: ["RPA.Read", "RPA.Write"],
                child: [],
            },
            {
                key: "5.4",
                header: "Bar and Restaurant Automation",
                path: "/admin/automation-logs/bar-and-restaurant-automation",
                component: ServiceRestartLogs,
                icon: "",
                roles: ["EPE.Read"],
                child: [],
            },
            {
                key: "5.5",
                header: "Pharmacy",
                path: "/admin/automation-logs/pharmacy",
                component: ServiceMainLogs,
                icon: "",
                roles: ["ServiceMain.Read"],
                child: [],
            },
            // {
            //     key: "5.6",
            //     header: "DevOps Automation",
            //     path: "/admin/automation-logs/devops-automation",
            //     component: IncidentSummary,
            //     icon: "",
            //     roles: ["CCLogs.Read", "CCLogs.Write"],
            //     child: [],
            // },
        ],
    },
    {
        key: "6",
        header: "Cradlepoint",
        path: "/admin/cradlepoint",
        component: <></>,
        icon: <CradlePointIcon />,
        activeIcon: <CradlePointActiveIcon />,
        roles: ["CpBilling.Write", "NcmUpdate.Read", "NcmUpdate.Write"],
        child: [
            {
                key: "6.1",
                header: "Billing Automation",
                path: "/admin/cradlepoint/billing-automation",
                component: CPUsageTracker,
                icon: "",
                roles: ["CpBilling.Write"],
                child: [],
            },
            {
                key: "6.2",
                header: "Deployment",
                path: "/admin/cradlepoint/deployment",
                component: CPDeployment,
                icon: "",
                roles: ["NcmUpdate.Read", "NcmUpdate.Write"],
                child: [],
            },
        ],
    },
    {
        key: "7",
        header: "OTA - Firmware",
        path: "/admin/ota-firmware",
        component: ShellyFirmware,
        icon: <ShellyFirmwareIcon />,
        activeIcon: <ShellyFirmwareActiveIcon />,
        roles: ["NetworkAutomation.Write"],
        child: [],
    },
 
     {
        key: "8",
        header: "Grafana Agent",
        path: "/admin/grafana-agent",
        component: <></>,          
        icon: <GrafanaAgentRemoteCommandIcon />,
        activeIcon: <GrafanaAgentRemoteCommandActiveIcon />,
        roles: ["GARemoteCommand.Read","GARemoteCommand.Write"],
        child: [
            {
                key: "8.1",
                header: "Grafana Server",
                path: "/admin/grafana-agent/server",
                component: GARemoteCommand,
                icon: "",
                roles: ["GARemoteCommand.Read","GARemoteCommand.Write"],
                child: [],
            },
            {
                key: "8.2",
                header: "Grafana Azure Standard VM Alloy",
                path: "/admin/grafana-agent/azure-vm-alloy",
                component: GAAzureVmAlloy,
                icon: "",
                roles: ["GARemoteCommand.Read","GARemoteCommand.Write"],
                child: [],
            },

        ],
    },



    {
        key: "9",
        header: "EIOT Incident Suppression",
        path: "/admin/incident-suppression",
        component: <></>,
        icon: <IncidentSuppressionIcon />,
        activeIcon: <IncidentSuppressionActiveIcon />,
        roles: ["IncidentSuppression.Read", "IncidentSuppression.Write"],
        child: [
            {
                key: "9.1",
                header: "Suppression Request",
                path: "/admin/incident-suppression/suppression-request",
                component: IncidentSuppressionRequest,
                icon: "",
                roles: ["IncidentSuppression.Write"],
                child: [],
            },
            {
                key: "9.2",
                header: "Suppression Logs",
                path: "/admin/incident-suppression/suppression-logs",
                component: IncidentSuppressionLogs,
                icon: "",
                roles: ["IncidentSuppression.Read"],
                child: [],
            },
        ],
    },
    {
        key: "10",
        header: "RESE",
        path: "/admin/rese",
        component: <></>,
        icon: <ReseIcon />,
        activeIcon: <ReseActiveIcon />,
        roles: ["ReseAlertSuppression.Read", "ReseAlertSuppression.Write"],
        child: [
            {
                key: "10.1",
                header: "Command and Control",
                path: "/admin/rese/rese-agent",
                component: RESECommand,
                icon: "",
                roles: ["ReseAlertSuppression.Write"],
                child: [],
            },
            {
                key: "10.2",
                header: "Alert Suppression Request",
                path: "/admin/rese/alert-suppression-request",
                component: ReseAlertSuppressionRequest,
                icon: "",
                roles: ["ReseAlertSuppression.Write"],
                child: [],
            },
            {
                key: "10.3",
                header: "Leak Detection Alert Suppression Request",
                path: "/admin/rese/leak-detection-alert-suppression-request",
                component: ReseLeakAlertSuppressionRequest,
                icon: "",
                roles: ["ReseAlertSuppression.Write"],
                child: [],
            },

            {
                key: "10.4",
                header: "Leak Detection Monitoring",
                path: "/admin/rese/leak-detection-monitoring",
                component: ReseLeakDetectionMonitoring,
                icon: "",
                roles: ["ReseAlertSuppression.Write"],
                child: [],
            },
            {
                key: "10.5",
                header: "Alert Suppression Logs",
                path: "/admin/rese/alert-suppression-logs",
                component: ReseAlertSuppressionLogs,
                icon: "",
                roles: ["ReseAlertSuppression.Read"],
                child: [],
            },
            {
                key: "10.6",
                header: "File Upload",
                path: "/admin/rese/rese-file-upload",
                component: ReseFileupload,
                icon: "",
                roles: ["ReseAlertSuppression.Write"],
                child: [],
            },
            {
                key: "10.7",
                header: "Users",
                path: "/admin/rese/rese-user-details",
                component: ReseUser,
                icon: "",
                roles: ["ReseAlertSuppression.Write"],
                child: [],
            },
            {
                key: "10.8",
                header: "Store",
                path: "/admin/rese/store",
                component: ReseStore,
                icon: "",
                roles: ["ReseAlertSuppression.Write"],
                child: [],
            },
            {
                key: "10.9",
                header: "BMS",
                path: "/admin/rese/bms",
                component: ReseBms,
                icon: "",
                roles: ["ReseAlertSuppression.Write"],
                child: [],
            }
            
        ],
    },
    {
        key: "11",
        header: "Data Categorization",
        path: "/admin/data-categorization",
        component: DataCategorization,
        icon: <DataCategorizationIcon />,
        activeIcon: <DataCategorizationActiveIcon />,
        roles: [],
        child: [],
    },
    {
        key: "12",
        header: "Supply Chain",
        path: "/admin/supply-chain",
        component: <></>,
        icon: <DeviceManagementIcon />,
        activeIcon: <DeviceManagementActiveIcon />,
        roles: [
            "AssetManagement.Read",
            "DeviceManagement.Read",
            "DeviceManagement.Write",
            "CommandControl.Read",
            "CommandControl.Write",
            "ShellyReplacement.Read",
            "ShellyReplacement.Write",
        ],
        child: [
            {
                key: "12.1",
                header: "Dashboard",
                path: "/admin/supply-chain/dashboard",
                component: Dashboard,
                icon: "",
                roles: ["DeviceManagement.Read"],
                child: [],
            },
            {
                key: "12.2",
                header: "Onboarding",
                path: "/admin/supply-chain/onboarding",
                component: DCOnboarding,
                icon: "",
                roles: ["DeviceManagement.Read"],
                child: [],
            },
               {
                key: "12.3",
                header: "Devices",
                path: "/admin/supply-chain/devices",
                component: DeviceDetailsTable,
                icon: "",
                roles: ["DeviceManagement.Read"],
                child: [],
            }
        ],
    },
];
